import { useMap, useMapEvents } from 'react-leaflet';
import { LatLngExpression } from 'leaflet';
import { usePreferencesStorage } from '@/hooks/usePreferencesStorage';

const MAP_ZOOM_LEVEL_PREFERENCES_KEY = 'map.zoomLevel';
const DEFAULT_MAP_ZOOM_LEVEL = 7;
const MAP_CENTER_POSITION_PREFERENCES_KEY = 'map.centerPosition';
const DEFAULT_MAP_CENTER_POSITION = [47.162494, 19.503304];

export function SavePositionComponent() {
  const map = useMap();
  const preferences = usePreferencesStorage();

  useMapEvents({
    zoomend: () => {
      const zoomLevel = map.getZoom();
      if (zoomLevel) {
        preferences.set(MAP_ZOOM_LEVEL_PREFERENCES_KEY, zoomLevel);
      }
    },
    moveend: () => {
      const centerPosition = map.getCenter();
      if (centerPosition) {
        preferences.setObject(MAP_CENTER_POSITION_PREFERENCES_KEY, centerPosition);
      }
    },
  });

  return null;
}

// eslint-disable-next-line
export function loadSavedPosition(): [number, LatLngExpression] {
  const preferences = usePreferencesStorage();
  const zoom = preferences.getOrDefault(MAP_ZOOM_LEVEL_PREFERENCES_KEY, DEFAULT_MAP_ZOOM_LEVEL);
  const center = preferences.getObjectOrDefault(MAP_CENTER_POSITION_PREFERENCES_KEY, DEFAULT_MAP_CENTER_POSITION);
  return [zoom, center];
}
